<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
	<div class="row">
	  <div class="col-12"></div>
	  <div class="col-12">
		<div class="card">
		  <div class="card-content">
			<div class="card-body">
			  <!-- ngx-datatable-filter -->
			  <fieldset class="form-group">
				<div class="row align-items-end mt-0 pagination-body">
				  <div class="col-12 col-sm-12 col-md-3 col-lg-3 mb-2">
					<ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
					[footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
					[count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>
				  </div>
				  
				  <div class="col-12 col-sm-12 col-md-9 col-lg-9 mt-2 mb-1">
					<div class="row-flex">
					  <div class="col-flex-2 mb-1 position-relative">
						<input id="ngx-filter-ref"
						  class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
						  type="text" (keydown.enter)="filter(searchVal)" placeholder="Search" #name [(ngModel)]="searchVal"  />
						<button class="btn search-btn glow position-absolute" (click)="filter(searchVal)">
						  <i class="ft-search text-white cursor-pointer"></i>
						</button>
					  </div>
					  <div class="col-flex-2 mb-1">
						<button class="btn btn-primary btn-block users-list-clear glow mb-0" >
						  Reset
						  <i class="ft-filter text-white cursor-pointer"></i>
						</button>
					  </div>
					</div>
				  </div>
				  <!-- <div class="col-12">
					<button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Tags Guideline</button>
					</div> -->
				</div>
			  </fieldset>
			  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
				[footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
				[columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.offset"
				(page)="pageChangeData($event)">
				<ngx-datatable-column name="Project Name" prop="name" [width]="120">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<div class="d-flex align-items-center">
					  <div class="cell-line-height cursor-pointer">
						<p class="font-medium-1 line-height-1 mb-0">
						  {{ row?.project_assign?.name }}
						</p>
					  </div>
					</div>
				  </ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Course" prop="course_id" [width]="70">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					  <div class="cell-line-height">
						<span class="badge badge-pill bg-light-info"> {{ row?.course_id?.title}}</span>
					  </div>
					</ng-template>
				</ngx-datatable-column>
			  </ngx-datatable>
			  <!-- ngx-datatable-filter -->
			</div>
		  </div>
		</div>
	  </div>
	</div>
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div>
  
  